import React, { useState, useEffect } from "react"
import { Modal } from "react-bootstrap"
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js"
import StripeLogo from "../../assets/images/stripeLogo.png"
import WorkeyeLogo from "../../assets/images/WE_text_tick.png"
import { useStaticQuery, graphql } from "gatsby"
import $ from "jquery"
import emailjs from "emailjs-com"

export default function CheckoutForm({ planamount, planname }) {
  const data = useStaticQuery(graphql`
    query {
      allContentfulTestDrivePlans(sort: { fields: createdAt }) {
        nodes {
          buttonOne
          taxText
          thankYouTextOne
          thankYouTextTwo
        }
      }
    }
  `)
  const { allContentfulTestDrivePlans } = data

  const [error, setError] = useState(null)
  const [processing, setProcessing] = useState("")
  const [disabled, setDisabled] = useState(true)
  const stripe = useStripe()
  const elements = useElements()

  const [visible, setVisible] = useState(false)
  const [visible2, setVisible2] = useState(false)

  const handleShow = () => setVisible2(true)
  const handleClose = () => setVisible(false)

  const testPlanNotification = e => {
    if (planname != "Once off payment") {
      e.preventDefault()
      emailjs
        .sendForm(
          "service_qkbep48",
          "template_6tdwkww",
          e.target,
          "user_H1giHzeT00K7WW4tInQOn"
        )
        .then(
          result => {
            console.log(result)
          },
          error => {
            console.log(error.text)
          }
        )
    } else {
      e.preventDefault()
    }
  }

  var amount = planamount
  if (amount.charAt(0) === "€") {
    amount = amount.substring(1, amount.length)
  } else {
    amount = amount.substring(0, amount.length)
  }
  amount = parseInt(amount) * 100

  useEffect(() => {
    // center popup box on screen
    $(".modal-dialog").addClass("modal-dialog-centered")
  })

  const cardStyle = {
    hidePostalCode: true,
    style: {
      base: {
        color: "#32325d",
        fontFamily: "Arial, sans-serif",
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#32325d",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  }
  const handleChange = async event => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    setDisabled(event.empty)
    setError(event.error ? event.error.message : "")

    if (event.error) {
      document.getElementById("submit").style.display = "none"
    } else {
      document.getElementById("submit").style.display = "block"
    }
  }

  const handleSubmit = async event => {
    event.preventDefault()
    setProcessing(true)

    const accountholderName = event.target["accountholder-name"].value
    const companyName = event.target["company-name"].value
    const email = event.target.email.value

    getClientSecret()

    async function getClientSecret() {
      const response = await fetch("/.netlify/functions/create-intent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          accountholderName: accountholderName,
          name: companyName,
          email: email,
          planType: planname,
          amount: amount,
        }),
      })
        .then(response => response.json())
        .then(handleResponse)
    }

    async function handleResponse(json) {
      sendToDatabase()

      async function sendToDatabase() {
        const paymentData = {
          name: json.name,
          email: json.email,
          planType: planname,
          payment: "card",
        }

        const response = await fetch("/.netlify/functions/store-customer", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(paymentData),
        })

        return response.json()
      }

      const clientSecret = json.clientSecret

      const payload = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      })
      if (payload.error) {
        setError(`Payment failed ${payload.error.message}`)
        setProcessing(false)
      } else {
        setError(null)
        setProcessing(false)
        //setSucceeded(true);
      }

      handleClose()
      handleShow()
    }
  }

  const resetForm = () => {
    setError(null)
    setProcessing(false)
    setDisabled(true)
  }

  return (
    <div>
      <form onSubmit={testPlanNotification}>
        <div className="form-group">
          <label className="sr-only">Plan name</label>
          <input value={planname} type="hidden" name="plan_name" />
        </div>
        <button
          type="submit"
          className="btn btn-primary"
          onClick={() => setVisible(true)}
        >
          {allContentfulTestDrivePlans.nodes[0].buttonOne}
        </button>
      </form>

      <Modal
        show={visible}
        onHide={() => {
          resetForm()
          setVisible(false)
        }}
        className="main-text-color"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {allContentfulTestDrivePlans.nodes[0].buttonOne}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="payment-form" onSubmit={handleSubmit}>
            <div className="text-center">
              <p>
                <h4>{planname}</h4>
              </p>
              <p>
                <h4>
                  <b>{planamount}</b>
                </h4>
              </p>
              {allContentfulTestDrivePlans.nodes[0].taxText}
            </div>

            <div className="form-row inline">
              <div class="w-100 ">
                <div className="col">
                  <label>
                    <div className="input-text">Full Name</div>
                    <div class="w-100 p-2">
                      <input
                        className="input-box"
                        name="accountholder-name"
                        placeholder="Jenny Rosen"
                        required
                      />
                    </div>
                  </label>
                </div>
              </div>

              <div class="w-100">
                <div className="col">
                  <label>
                    <div className="input-text">Email Address</div>
                    <div class="w-100 p-2">
                      <input
                        className="input-box"
                        name="email"
                        type="email"
                        placeholder="jenny.rosen@example.com"
                        required
                      />
                    </div>
                  </label>
                </div>
              </div>

              <div class="w-100 ">
                <div className="col">
                  <label>
                    <div className="input-text">Company Name</div>
                    <div class="w-100 p-2">
                      <input
                        className="input-box"
                        name="company-name"
                        placeholder="Example company"
                        required
                      />
                    </div>
                  </label>
                </div>
              </div>
            </div>

            <div class="w-100 p-3">
              <div className="form-column">
                <label>Card Details</label>
                <CardElement
                  id="card-element"
                  options={cardStyle}
                  onChange={handleChange}
                />
              </div>
            </div>

            <center>
              {/* Show any error that happens when processing the payment */}
              {error && (
                <div
                  className="card-error"
                  class="text-danger pt-3"
                  role="alert"
                >
                  {error}
                </div>
              )}

              <button
                className="btn btn-primary mt-3"
                disabled={processing || disabled}
                id="submit"
              >
                <span id="button-text">
                  {processing ? (
                    <div className="spinner" id="spinner"></div>
                  ) : (
                    "Pay"
                  )}
                </span>
              </button>

              <div>
                <img
                  src={StripeLogo}
                  alt="Stripe Logo"
                  classname="stripeLogo"
                />
                <img
                  src={WorkeyeLogo}
                  alt="Workeye Logo"
                  classname="workeyeLogo"
                  height={40}
                />
              </div>
            </center>
          </form>
        </Modal.Body>
      </Modal>

      <Modal
        show={visible2}
        onHide={() => setVisible2(false)}
        className="main-text-color"
      >
        <Modal.Header closeButton>
          {allContentfulTestDrivePlans.nodes[0].thankYouTextOne}
        </Modal.Header>
        <Modal.Body>
          {allContentfulTestDrivePlans.nodes[0].thankYouTextTwo}
        </Modal.Body>
      </Modal>
    </div>
  )
}
